import './Card.css'
import { MdOutlineMultipleStop } from "react-icons/md";
import { RxPeople } from "react-icons/rx";
import { IoDiamondOutline } from "react-icons/io5";
import { PiSealCheckLight } from "react-icons/pi";

const Card_con = () => {
  return (
    <>
    <div className='title_con'>
        <div className='Con_title'>
            Prestige
        </div>
    </div>
    <div className='grid-container_container'>
        <div className='card_con'>
            <div className='wrapper_catering'>
                <div className='card_area'>
                    <div className='card_consultant'>
                        <div className='over'>
                            <div className='con_card'>
                                <RxPeople className='icon_con' />
                                <p>
                                   Med kompromisslös kvalitet, personlig service och känsla 
                                   för varje detalj skapar vi exklusiva upplevelser där 
                                   ingenting lämnas åt slumpen.
                                </p>
                            </div>
                        </div>
                    </div>
                    <div className='card_consultant'>
                        <div className='over'>
                            <div className='con_card'>
                                <MdOutlineMultipleStop className='icon_con'/>
                                <p>
                                    Skapa en oförglömlig upplevelse i en miljö utöver det vanliga.
                                    Vi hjälper dig att hitta den perfekta lokalen och skräddarsyr 
                                    varje detalj efter din vision – för ett elegant, personligt 
                                    och exklusivt event.
                                </p>
                            </div>
                        </div>
                    </div>
                     <div className='card_consultant'>
                        <div className='over'>
                            <div className='con_card'>
                                <IoDiamondOutline className='icon_con'/>
                                <p>
                                    Kvalitet utan kompromisser. Vi kombinerar noggrant utvalda råvaror, 
                                    professionell service och känsla för detaljer för att skapa 
                                    en upplevelse som både imponerar och blir ihågkommen.
                                </p>
                            </div>
                        </div>
                    </div>
                     <div className='card_consultant'>
                        <div className='over'>
                            <div className='con_card'>
                                <PiSealCheckLight className='icon_con'/>
                                <p>
                                    Trygghet från start till mål. Vi tar ansvar 
                                    för helheten och ser till att allt flyter 
                                    smidigt – från första planeringen till sista 
                                    gästen lämnar. Ni kan koppla av och njuta, 
                                    medan vi tar hand om resten.
                                </p>
                            </div>
                        </div>
                    </div>
                    
                </div>
            </div>
        </div>
    </div>
</>
  )
}

export default Card_con